import { ROUTE_PATH_MANAGER } from "page/deck-manager/deck-manager-config";

export const ROUTE_PATH_DECKMANAGER_SAVE = `${ROUTE_PATH_MANAGER}save`;
